export default __webpack_public_path__ + "static/media/Flag_of_Zimbabwe.ca1c9cd9.svg";